export const dropdownNodes = ({
                                view,
                                id,
                                name,
                                text,
                                settings = {},
                                multiple = false,
                                searchable = true,
                                clearable = true
                              }) => ([
  view.state.schema.nodes.form_label.create({id},
      view.state.schema.text(text)),
  view.state.schema.nodes.form_select.create({
    id,
    name,
    multiple,
    settings,
    searchable,
    clearable,
  }),
]);